import type {
    ReactiveCatalogKeyPart,
    ReactiveDateSerializerFormat,
    ReactiveFieldSerializerDefinition,
    ReactiveFormSerializerMode,
    ReactiveRepeatableSerializerTargets,
} from '../interfaces/reactive-form-serializer.interface';

type SerializerOptions = Omit<ReactiveFieldSerializerDefinition, 'mode'>;
type SerializerOptionsWithoutSource = Omit<SerializerOptions, 'source'>;

export class ReactiveFormSerializers {
    public static value(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { ...options, mode: 'value' };
    }

    public static copyFrom(
        source: string,
        options: SerializerOptionsWithoutSource = {},
    ): ReactiveFieldSerializerDefinition {
        return { removeSource: false, ...options, source, mode: 'value' };
    }

    public static join(separator = ';', options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { ...options, separator, mode: 'join' };
    }

    public static legacyBoolean(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { trueValue: 1, falseValue: 0, ...options, mode: 'boolean' };
    }

    public static date(
        dateFormat: ReactiveDateSerializerFormat = 'iso',
        options: SerializerOptions = {},
    ): ReactiveFieldSerializerDefinition {
        return { ...options, dateFormat, mode: 'date' };
    }

    public static time(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { ...options, mode: 'time' };
    }

    public static catalogKey(
        catalogKeyPart: ReactiveCatalogKeyPart = 'last',
        options: SerializerOptions = {},
    ): ReactiveFieldSerializerDefinition {
        return { ...options, catalogKeyPart, mode: 'catalogKey' };
    }

    public static catalogBackendValue(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { catalogKeyPart: 'last', ...options, mode: 'catalogBackendValue' };
    }

    public static optionRawValue(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { ...options, mode: 'optionRawValue' };
    }

    public static nullableEmpty(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { emptyValue: null, ...options, mode: 'nullableEmpty' };
    }

    public static omitEmpty(
        mode: ReactiveFormSerializerMode = 'value',
        options: SerializerOptions = {},
    ): ReactiveFieldSerializerDefinition {
        return { ...options, mode, omitWhen: 'empty' };
    }


    public static repeatableAggregate(
        repeatableTargets: ReactiveRepeatableSerializerTargets,
        options: SerializerOptions = {},
    ): ReactiveFieldSerializerDefinition {
        return { ...options, repeatableTargets, mode: 'repeatableAggregate' };
    }

    public static repeatableSlots(
        repeatableTargets: ReactiveRepeatableSerializerTargets,
        options: SerializerOptions = {},
    ): ReactiveFieldSerializerDefinition {
        return { ...options, repeatableTargets, mode: 'repeatableSlots' };
    }

    public static repeatableJson(options: SerializerOptions = {}): ReactiveFieldSerializerDefinition {
        return { repeatableJsonString: true, ...options, mode: 'repeatableJson' };
    }
}
